import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { getRoleLabel } from '../../config/permissions';

/**
 * Faixa permanente durante um "acessar como". Fica grudada no topo da área de
 * conteúdo para que ninguém confunda a sessão de suporte com a própria conta.
 */
const ImpersonationBanner: React.FC = () => {
  const { user, impersonatedBy, stopImpersonation } = useAuth();

  if (!impersonatedBy || !user) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        px: 2,
        py: 1,
        bgcolor: '#fef3c7',
        borderBottom: '1px solid #f59e0b',
        color: '#78350f',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <LoginIcon fontSize="small" />
        <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>
          Você está acessando como {user.full_name} ({getRoleLabel(user.role)})
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.85 }} noWrap>
          Acesso aberto por {impersonatedBy.name}
        </Typography>
      </Box>
      <Button
        size="small"
        variant="contained"
        onClick={stopImpersonation}
        sx={{
          bgcolor: '#b45309',
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': { bgcolor: '#92400e' },
        }}
      >
        Sair do acesso
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
